// ----------------------------------------------------------------------------
// Component: In the Box Section - PDP
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';

// Styles
import './_in-the-box.scss';


